import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GridErrorBoundaryFallback } from 'components/common';
import FlowForm from './FlowForm';

const AddFlow: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <FlowForm />
    </ErrorBoundary>
  );
};

export default AddFlow;